const shopDictPT = {
  seeProduct: "Ver produto",
  firstBannerText: "O marketplace que te recompensa sempre",
  secondaryBannerText: "Faça parte da Extraconomy",
  secondaryBannerButtonText: "Conheça nossos planos",
  secondaryBannerText2: "Aumente seu poder econômico",
  searchQueryText: "Você pesquisou por:",
  subCategoryFilter: "Subcategorias",
  noProductsInCategory: "Não possui produtos",
  noProductsInSearch: "Nenhum produto encontrado",
  noSubcategories: "Não possui subcategorias",
  filters: "Filtros",
  downloadable: "Baixável",
  brazil: "Brasil",
  mexico: "México",
  italy: "Itália",
  brl: "BRL",
  mxn: "MXN",
  eur: "EUR",
  usd: "USD",
  gbp: "GBP",
  try: "TRY",
  results: "Resultados",
  result: "Resultado",
  selectStore: "Selecione uma loja",
  store: "Loja",
  filter: "Filtrar",
  registerAsCustomerFree: "Cadastre-se como Customer gratuitamente",
  register2: "Cadastre-se",
  selectCategory: "Selecione o Departamento",
  allDepartments: "Todos os Departamentos",
  departments: "Departamentos",
  discoverAllDepartments: "Descubra todos os nossos departamentos",
  seeBellowAllDepartments:
    "Veja abaixo todos os nossos departamentos disponíveis na loja e filtre produtos pelo seu departamento preferido.",
  linkCopied: "Link copiado",
  errorCopyingLink: "Erro ao copiar o link",
  sharedSuccessfully: "Compartilhado com sucesso",
  sharingCanceled: "Compartilhamento cancelado",
  errorSharing: "Erro ao compartilhar",
  findPartnersNearYou: "Encontre parceiros Extraconomy perto de você",
  useOurMap:
    "Descubra empresas, serviços e produtos que fazem parte da nova economia colaborativa. Use o mapa para localizar parceiros próximos, aproveitar benefícios e movimentar a circularidade financeira ao seu redor.",
  buyLocally:
    "Ao comprar de parceiros próximos, você fortalece a economia local, acumula recompensas e participa de uma rede mais justa para todos.",
  value: "Valor",
  bank: "Banco",
  transferToThisBank: "Você deverá realizar a transferêcia com os seguintes dados:",
  fringeBenefits: "Fringe Benefits",
  readMore: "Saiba mais",
};

export default shopDictPT;
